import { render, staticRenderFns } from "./allorderlist.vue?vue&type=template&id=f3e59680&scoped=true&"
import script from "./allorderlist.vue?vue&type=script&lang=js&"
export * from "./allorderlist.vue?vue&type=script&lang=js&"
import style0 from "./allorderlist.vue?vue&type=style&index=0&id=f3e59680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e59680",
  null
  
)

export default component.exports